/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS

import { getApplicationLocalStorageItem } from './src/helpers'

const layout_config = JSON.parse(getApplicationLocalStorageItem('layout'))

export const colors = {
  primary: "#7367F0",
  success: "#28C76F",
  danger: "#EA5455",
  warning: "#FF9F43",
  dark: "#1E1E1E"
};

let web_footer_type_id = 0;
let web_theme_mode_id = 0;
let web_main_menu_layout_type_id = 0;
let web_navbar_type_id = 0;
let animation_type_id = 0;
let navbar_color = "#fff";
let scroll_to_top_button = false;
let rtl = false;
let can_customizer = false;
let web_main_menu_collapsed = false;
let web_theme_color = "#7367F0";

const animation_types = [
  "zoom-fade",
  "slide-fade",
  "fade-bottom",
  "fade",
  "zoom-out",
  "none"
];
const footer_types = ["static", "sticky", "hidden"];
const menu_layout_types = ["vertical", "horizontal"];
const navbar_types = ["floating", "static", "sticky", "hidden"];
const theme_types = ["light", "dark", "semi-dark"];

if (layout_config) {
  web_footer_type_id = layout_config["footer_type_id"] - 1;
  web_main_menu_layout_type_id = layout_config["main_menu_layout_type_id"] - 1;
  web_navbar_type_id = layout_config["navbar_type_id"] - 1;
  animation_type_id = layout_config["animation_type_id"] - 1;
  scroll_to_top_button = layout_config["scroll_to_top_button"];
  navbar_color = layout_config["navbar_color"];
  web_main_menu_layout_type_id = layout_config["main_menu_layout_type_id"] - 1;
  web_main_menu_collapsed = layout_config["main_menu_collapsed"];
  web_theme_color = layout_config["theme_color"];
  colors.primary = web_theme_color;
  // web_theme_color = theme_types.includes(layout_config['theme_color']) ? layout_config['theme_color'] : 'light'
  web_theme_mode_id = theme_types[layout_config["theme_mode_id"] - 1];
  can_customizer = layout_config["permissions"];
  rtl = layout_config["rtl"];
}

// CONFIGS
const themeConfig = {
  disableCustomizer: can_customizer, // options[Boolean] : true, false(default)
  disableThemeTour: true, // options[Boolean] : true, false(default)
  footerType: footer_types[web_footer_type_id], // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: scroll_to_top_button, // options[Boolean] : true, false(default)
  mainLayoutType: menu_layout_types[web_main_menu_layout_type_id], // options[String]  : vertical(default) / horizontal
  navbarColor: navbar_color, // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: navbar_types[web_navbar_type_id], // options[String]  : floating(default) / static / sticky / hidden
  routerTransition: animation_types[animation_type_id], // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl, // options[Boolean] : true, false(default)
  sidebarCollapsed: web_main_menu_collapsed, // options[Boolean] : true, false(default)
  theme: web_theme_mode_id, // options[String]  : "light"(default), "dark", "semi-dark"

  // Not required yet - WIP
  userInfoLocalStorageKey: "userInfo"
  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

import Vue from "vue";
import Vuesax from "vuesax";

Vue.use(Vuesax, { theme: { colors }, rtl: themeConfig.rtl });

export default themeConfig;
